import axios from 'axios'
import { useEffect, useState } from 'react'

export interface LatestProductOrders {
  crn: string
  // currentSupportExpiry is the support expiry of the customer's current
  // product, resolved server-side (ISO 8601). Absent when there's no matching
  // order or no recorded expiry — render it directly, no matching needed.
  currentSupportExpiry?: string
}

export interface LatestProductOrdersState {
  data: LatestProductOrders | null
  loading: boolean
  error: Error | null
}

export function useLatestProductOrders(teamID: string, customerID: string): LatestProductOrdersState {
  const [state, setState] = useState<LatestProductOrdersState>({ data: null, loading: true, error: null })

  useEffect(() => {
    const controller = new AbortController()
    setState({ data: null, loading: true, error: null })

    axios
      .get<LatestProductOrders>(`/api/teams/${teamID}/customers/${customerID}/orders`, {
        signal: controller.signal,
      })
      .then(resp => {
        setState({ data: resp.data, loading: false, error: null })
      })
      .catch(err => {
        if (axios.isCancel(err)) return
        if (err?.response?.status === 404) {
          setState({ data: null, loading: false, error: null })
          return
        }
        setState({ data: null, loading: false, error: err instanceof Error ? err : new Error(String(err)) })
      })

    return () => {
      controller.abort()
    }
  }, [teamID, customerID])

  return state
}
